module.exports = __webpack_public_path__ + "img/3-2.2bb14ab1.png";